import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters' 
  
const STATES = {
  IDLE: 'IDLE',
  TAP_HOLD_PROGRESS: 'TAP_HOLD_PROGRESS',
  TAP_HOLD_RECORD: 'TAP_HOLD_RECORD',
  TAP_HOLD_RELEASE: 'TAP_HOLD_RELEASE',
  PROCESSING: 'THINKING',
  COMPLETE: 'COMPLETE',
  REPLAY: 'REPLAY',
  ERROR: 'ERROR',
  INTRO: 'INTRO'
};


const GOALS = {
  ANGRY: 0,
  SAD: 1,
  CONFUSED: 4,
  HAPPY:  8
}

const state = {

  STATES: STATES,
  state: null,
  tap_hold_ratio: 0,
  tap_hold_cta: false,
  tap_hold_cta_valid: true,
  timer_ratio: 1,

  initialShow: true,
  NUM_OF_EXPRESSIONS: 10,

  frequencyData: null,

  GOALS: GOALS,
  collection: [
    {
      id: GOALS.SAD,
      title: 'Sad',
      complete: false,
      bait: 'Come on! Make me SAD!',
      congrats: 'Aww your mean! nicely done.',
      copy: {
        intro: 'SAD :(',
        outro: 'SAD :('
      }
    },
    {
      id: GOALS.ANGRY,
      title: 'Furious',
      complete: false,
      bait: 'Is that all you’ve got? you can do better than that!',
      congrats: "Ouch! nicely done. A++",
      copy: {
        intro: 'FURIOUS',
        outro: 'FURIOUS'
      }
    },
    {
      id: GOALS.CONFUSED,
      title: 'Confused', 
      complete: false,
      congrats: "Congrats, I'm thoroughly mythed!",
      baitNeg: 'Do you seek to anger me !!? confuse me idiot!',
      baitPos: 'Hmmmm, you made me happier but not confused!',
      copy: {
        intro: 'CONFUSED',
        outro: 'CONFUSED'
      }
    },
    {
      id: GOALS.HAPPY,
      title: 'Happy',
      complete: false,
      congrats: "You did it.. ;)",
      bait: 'Meh, try harder, make me HAPPY!', 
      copy: {
        intro: 'HAPPY :)',
        outro: 'HAPPY :)'
      }
    }
  ],
  
  

  
  goal: null, // target goal
  goals_completed: false,

  transcription: null,
  targetIndex: 0,
  result: {
    bait: '',
    score: 0,
    percentage: 0,
    magnitude: 0,
    index: -1
  }
}

// EXPORT
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
